export const YEAR = 'year';

export const MONTH = 'month';

export const WEEK = 'week';

export const DAY = 'day';
